import React, { useEffect, useState } from "react";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../helpers/spinner";
import helperNumbers from "../../../../helpers/numbers";
import helpersTime from "../../../../helpers/time";
import { Link } from "react-router-dom";

export default function ReportPosition() {
  const [reportPosition, setReportPosition] = useState(null);

  const sendForm = async () => {
    const tagHtmlID = document.querySelector("#tag-html-id").value.trim();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultGetReportPosition = await sendRequestGetReportPosition(
      tagHtmlID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultGetReportPosition) {
      setReportPosition(null);
      return;
    }
    setReportPosition(resultGetReportPosition);
  };

  const sendRequestGetReportPosition = async (tagHtmlID) => {
    const headersRequest = getHeaderForRequest();
    let reportPosition;
    try {
      reportPosition = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/manage/report/" +
          tagHtmlID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return reportPosition.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const removeCampaign = async (campaignID, typeStatusCampaign) => {
    const positionTagHtmlID = reportPosition.pos_tag_html_id;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestRemoveCampaign = await sendRequestRemoveCampaign(
      positionTagHtmlID,
      {
        campaign_ID: campaignID + "",
        campaign_type_status: typeStatusCampaign,
      }
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestRemoveCampaign) {
      return;
    }
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    setTimeout(() => {
      sendForm();
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    }, 3000);
  };

  const sendRequestRemoveCampaign = async (positionTagHtmlID, data) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API +
          `/v1/position/manage/${positionTagHtmlID}/remove-campaign-manually`,
        data,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const generateReportPositionCampaignActive = () => {
    let campaignIDSActive = reportPosition.campaign_IDS_active;
    return (
      <>
        <hr />
        <h4 className="text text-danger">
          کمپین های در حالت فعال برای این جایگاه
        </h4>
        <table className="table table-hilite tbl-td-white-space">
          <thead>
            <tr>
              <td>شماره کمپین</td>
              <td>تاریخ شروع</td>
              <td>تاریخ پایان</td>
              <td>حذف</td>
            </tr>
          </thead>
          <tbody>
            {campaignIDSActive.map((item) => {
              return (
                <tr>
                  <td>{item.id}</td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.start_date) +
                        " 00:00"
                    )}
                  </td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.end_date) +
                        " 23:59"
                    )}
                  </td>
                  <td>
                    <span
                      className="btn btn-danger"
                      onClick={() => {
                        removeCampaign(item.id, "active");
                      }}
                    >
                      <i className="fa fa-trash"></i>
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <hr />
      </>
    );
  };

  const generateReportPositionCampaignPending = () => {
    let campaignIDSPending = reportPosition.campaign_IDS_pending;
    return (
      <>
        <hr />
        <h4 className="text text-warning">
          کمپین های در حال انتظار برای این جایگاه
        </h4>
        <table className="table table-hilite tbl-td-white-space">
          <thead>
            <tr>
              <td>شماره کمپین</td>
              <td>تاریخ شروع</td>
              <td>تاریخ پایان</td>
              <td>حذف</td>
            </tr>
          </thead>
          <tbody>
            {campaignIDSPending.map((item) => {
              return (
                <tr>
                  <td>{item.id}</td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.start_date) +
                        " 00:00"
                    )}
                  </td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.end_date) +
                        " 23:59"
                    )}
                  </td>
                  <td>
                    <span
                      className="btn btn-danger"
                      onClick={() => {
                        removeCampaign(item.id, "pending");
                      }}
                    >
                      <i className="fa fa-trash"></i>
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <hr />
      </>
    );
  };

  const generateReportPositionCampaignActiveAlternative = () => {
    let campaignIDSPending = reportPosition.campaign_IDS_active_alternative;
    return (
      <>
        <hr />
        <h4 className="text text-warning">
          کمپین های جایگزین فعال برای این جایگاه
        </h4>
        <table className="table table-hilite tbl-td-white-space">
          <thead>
            <tr>
              <td>شماره کمپین</td>
              <td>تاریخ شروع</td>
              <td>تاریخ پایان</td>
              <td>حذف</td>
            </tr>
          </thead>
          <tbody>
            {campaignIDSPending.map((item) => {
              return (
                <tr>
                  <td>{item.id}</td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.start_date) +
                        " 00:00"
                    )}
                  </td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.end_date) +
                        " 23:59"
                    )}
                  </td>
                  <td>
                    <span
                      className="btn btn-danger"
                      onClick={() => {
                        removeCampaign(item.id, "active_alternative");
                      }}
                    >
                      <i className="fa fa-trash"></i>
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <hr />
      </>
    );
  };

  const generateReportPositionCampaignPendingAlternative = () => {
    let campaignIDSPendingAlternative =
      reportPosition.campaign_IDS_pending_alternative;
    return (
      <>
        <hr />
        <h4 className="text text-warning">
          کمپین های جایگزین در حال انتظار برای این جایگاه
        </h4>
        <table className="table table-hilite tbl-td-white-space">
          <thead>
            <tr>
              <td>شماره کمپین</td>
              <td>تاریخ شروع</td>
              <td>تاریخ پایان</td>
              <td>حذف</td>
            </tr>
          </thead>
          <tbody>
            {campaignIDSPendingAlternative.map((item) => {
              return (
                <tr>
                  <td>{item.id}</td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.start_date) +
                        " 00:00"
                    )}
                  </td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.end_date) +
                        " 23:59"
                    )}
                  </td>
                  <td>
                    <span
                      className="btn btn-danger"
                      onClick={() => {
                        removeCampaign(item.id, "pending_alternative");
                      }}
                    >
                      <i className="fa fa-trash"></i>
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <hr />
      </>
    );
  };

  const sendFormAddCampaignToPosition = async (e) => {
    e.preventDefault();
    const campaignID = document.querySelector("#campaign-id").value;
    const typeStatusCampaign = document.querySelector(
      "#type-status-campaign"
    ).value;
    const positionTagHtmlID = reportPosition.pos_tag_html_id;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestAddCampaignToPosition =
      await sendRequestAddCampaignToPosition(positionTagHtmlID, {
        campaign_ID: campaignID + "",
        campaign_type_status: typeStatusCampaign,
      });
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestAddCampaignToPosition) {
      return;
    }
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    setTimeout(() => {
      sendForm();
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    }, 3000);
  };

  const sendRequestAddCampaignToPosition = async (positionTagHtmlID, data) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API +
          `/v1/position/manage/${positionTagHtmlID}/add-campaign-manually`,
        data,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const generateTagHtmlAddCampaignToStatus = () => {
    return (
      <form
        className="d-flex align-items-end py-2"
        onSubmit={sendFormAddCampaignToPosition}
      >
        <div>
          <label>شماره کمپین</label>
          <input
            className="form-control"
            placeholder="شماره کمپین"
            id="campaign-id"
            type="number"
            required
          />
        </div>
        <div className="px-3">
          <label>حالت نوع کمپین</label>
          <select className="form-control" id="type-status-campaign">
            <option value="active">فعال</option>
            <option value="pending">در حال انتظار</option>
            <option value="active_alternative">فعال جایگزین</option>
            <option value="pending_alternative">در حال انتظار جایگزین</option>
          </select>
        </div>
        <div>
          <button className="btn btn-primary">
            اضافه کردن کمپین به جایگاه
          </button>
        </div>
      </form>
    );
  };

  return (
    <>
      <Sidebar
        openItem="manage-category-publisher-menu"
        activeItem="report-position"
      />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  مدیریت سایت های نمایش دهنده
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="pb-2">
                <span>
                  <Link
                    to="/manage/publishers/report/all-positions-in-site-publisher"
                    className="btn btn-primary"
                  >
                    گزارش جایگاه های سایت نمایش دهنده
                  </Link>
                </span>
                <span className="px-2">
                  <Link
                    to="/manage/publishers/check-position-campaign"
                    className="btn btn-primary"
                  >
                    {" "}
                    بررسی موجود بودن کمپین در جایگاه ها
                  </Link>
                </span>
                <span className="px-2">
                  <Link
                    to="/manage/publishers/manage/check-positions-have-duplicate-campaign"
                    className="btn btn-primary"
                  >
                    {" "}
                    بررسی تکراری بودن کمپین در جایگاه ها
                  </Link>
                </span>
              </div>

              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  sendForm();
                }}
                className="d-flex align-items-end"
              >
                <div className="form-group flex-grow-1">
                  <label>تگ html تبلیغ </label>{" "}
                  <span dir="ltr">( hilite-position- )</span>
                  <input
                    type="text"
                    className="form-control"
                    id="tag-html-id"
                    placeholder="تگ html تبلیغ"
                    required
                  />
                </div>
                <div className="form-group pr-2">
                  <button className="btn btn-primary" id="show-information">
                    نمایش اطلاعات
                  </button>
                </div>
              </form>

              {reportPosition !== null ? (
                generateTagHtmlAddCampaignToStatus()
              ) : (
                <></>
              )}

              {reportPosition !== null ? (
                <>
                  {reportPosition.campaign_IDS_active.length !== 0 ? (
                    generateReportPositionCampaignActive()
                  ) : (
                    <p className="alert alert-primary">
                      این جایگاه هیچ کمپین در حالت فعال ندارد
                    </p>
                  )}
                </>
              ) : (
                <></>
              )}

              {reportPosition !== null ? (
                <>
                  {reportPosition.campaign_IDS_pending.length !== 0 ? (
                    generateReportPositionCampaignPending()
                  ) : (
                    <p className="alert alert-primary">
                      این جایگاه هیچ کمپین در حالت انتظار ندارد
                    </p>
                  )}
                </>
              ) : (
                <></>
              )}

              {reportPosition !== null ? (
                <>
                  {reportPosition.campaign_IDS_active_alternative.length !==
                  0 ? (
                    generateReportPositionCampaignActiveAlternative()
                  ) : (
                    <p className="alert alert-primary">
                      این جایگاه هیچ کمپین جایگزین در حالت فعال ندارد{" "}
                    </p>
                  )}
                </>
              ) : (
                <></>
              )}

              {reportPosition !== null ? (
                <>
                  {reportPosition.campaign_IDS_pending_alternative.length !==
                  0 ? (
                    generateReportPositionCampaignPendingAlternative()
                  ) : (
                    <p className="alert alert-primary">
                      این جایگاه هیچ کمپین جایگزین در حالت انتظار ندارد
                    </p>
                  )}
                </>
              ) : (
                <></>
              )}

              {reportPosition !== null ? (
                <table className="table table-hilite tbl-td-white-space">
                  <thead>
                    <tr>
                      <td
                        colSpan={2}
                        className="text-center"
                        style={{ borderRadius: "25px 25px 0 0" }}
                      >
                        اطلاعات جایگاه
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>شماره جایگاه</td>
                      <td>{reportPosition.pos_id}</td>
                    </tr>
                    <tr>
                      <td>شماره صفحه</td>
                      <td>{reportPosition.pos_page_id}</td>
                    </tr>
                    <tr>
                      <td>آدرس صفحه</td>
                      <td dir="ltr" className="text-left ">
                        <span className="pr-2">
                          {reportPosition.website_url}
                        </span>
                        <a
                          target="_blank"
                          className="btn btn-primary"
                          href={reportPosition.website_url}
                        >
                          <i className="fa fa-link"></i>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>الگو صفحه</td>
                      <td dir="ltr" className="text-left ">
                        {reportPosition.pattern_url}
                      </td>
                    </tr>
                    <tr>
                      <td>اندازه</td>
                      <td>
                        <span>ارتفاع = </span>
                        <span>
                          {helperNumbers.toPersianNum(
                            reportPosition.pos_size.split("-")[1]
                          )}
                        </span>
                        <span className="px-3">عرض = </span>
                        <span>
                          {helperNumbers.toPersianNum(
                            reportPosition.pos_size.split("-")[0]
                          )}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>تعداد بنر</td>
                      <td>{reportPosition.pos_count}</td>
                    </tr>
                    <tr>
                      <td>قیمت پایه جایگاه</td>{" "}
                      <td>
                        <span className="letter-spacing-finance-number">
                          {helperNumbers.toPersianNum(
                            helperNumbers.toFormatFinanceNumber(
                              reportPosition.pos_base_price
                            )
                          )}
                        </span>
                        <span className="pr-2">تومان</span>
                      </td>
                    </tr>
                    <tr>
                      <td>قیمت جایگاه( یک بنر در یک شبانه روز)</td>{" "}
                      <td>
                        <span className="letter-spacing-finance-number">
                          {helperNumbers.toPersianNum(
                            helperNumbers.toFormatFinanceNumber(
                              reportPosition.pos_price
                            )
                          )}
                        </span>
                        <span className="pr-2">تومان</span>
                      </td>
                    </tr>
                    <tr>
                      <td>امتیاز </td>{" "}
                      <td className="letter-spacing-finance-number">
                        {helperNumbers.toPersianNum(
                          helperNumbers.toFormatFinanceNumber(
                            reportPosition.pos_alternative_price
                          )
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              ) : (
                <></>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
